import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ProductTabDeliveryAndReturnModel } from 'autogen/swagger/all';
import { Here } from 'autogen/translation-keys/trans-website-shared';
import InlineButton from 'components/generic/InlineButton';
import format from 'helpers/translations';

async function openModal(url): Promise<void> {
    const { default: htmlModal } = await import(/* webpackChunkName: "htmlModal" */ 'modules/modal/htmlModal');
    const modal = htmlModal();

    modal({ open: true, url });
}

function Button(url): JSX.Element {
    const { t } = useTranslation();

    return (
        <InlineButton variant="dark" onClick={() => openModal(url)}>
            {t(Here)}
        </InlineButton>
    );
}

export default function DeliveryAndReturn({ ...props }: ProductTabDeliveryAndReturnModel): JSX.Element {
    const { content, termsOfTradeUrl } = props;

    return format(content, Button(termsOfTradeUrl));
}
